<!--
Download screen

TODO: componentize this somehow - lots of repetition in there

@author bmk11u
-->
<template>
  <div id="contain" class="container">
    <Nav name="Sync Calendar" :step="true" />
      <main id="subscribemain" class="p-2 pb-4">
        <h1 id="synctitle">Sync Your Calendar</h1>
        <div id="syncCalNotice">
          <font-awesome-icon id="attentionIcon" icon="circle-exclamation"/><p>For the most up-to-date information and to subscribe to late change alerts, we recommend using the UofG Life App for personalised timetabling services.</p>
        </div>
        <p>Choose your device:</p>
        <ul id="syncLinks">
          <li><a href="https://glasgow.saasiteu.com/Modules/SelfService/#knowledgeBase/view/24C6018FE61249E6A106C38E52431BE5" target="_blank"><span>Android</span> <font-awesome-icon  icon="chevron-right"/></a></li>
          <li><a href="https://glasgow.saasiteu.com/Modules/SelfService/#knowledgeBase/view/DF75230BB976494586A1455806AD0C59" target="_blank"><span>iPhone/iPad</span> <font-awesome-icon icon="chevron-right"/></a></li>
          <li><a href="https://glasgow.saasiteu.com/Modules/SelfService/#knowledgeBase/view/C344039E703344E2AA21EBEC4FADB62D" target="_blank"><span>Mac</span> <font-awesome-icon  icon="chevron-right"/></a></li>
          <li><a href="https://glasgow.saasiteu.com/Modules/SelfService/#knowledgeBase/view/E69CE98EC8AB4C87B395B3033BA642F8" target="_blank"><span>Outlook for Windows</span>  <font-awesome-icon icon="chevron-right"/></a></li>
        </ul>

      </main>
    <div id="pusher"></div>
      <Footer active="download"/>
      <CopyComplete item="server address" />
  </div>
</template>

<script setup>
//Utilities
import { ref, onMounted } from 'vue'
import $ from 'jquery'
import ClipboardJS from 'clipboard'

//Composables
import { useDeviceType } from '@/composables/DeviceCommon.js'
const os = useDeviceType()

//Components
import CopyComplete from '@/components/CopyComplete.vue'
import Footer from '@/components/FooterMenu.vue'

//Data
const devices =  ref([
  { name: 'iOS', title: 'View iPhone / iPad instructions' },
  { name: 'Macintosh', title: 'View Mac instructions' },
  { name: 'Windows', title: 'View Outlook 365 (desktop) instructions' },
  { name: 'Android', title: 'View Android instructions' }
])
const device =  ref(null)
const icsUrl =  ref('frontdoor.spa.gla.ac.uk/spacett/download/uogtimetable.ics')
const clipboardAvailable =  ref(ClipboardJS.isSupported())

onMounted(
  () => {
    device.value = os.value
  }
)

function copyUrl (icsProtocol) {
  copyText(icsProtocol + icsUrl.value)
  $('#copyCompleteModal').modal('show')
}

function allExcept (devName) {
    return devices.value.filter(d => d.name != devName)
}

</script>

<style lang='scss'>
#synctitle {
    color: var(--uog-dark-blue);
    font-weight: 700;
    font-size: 1.5rem;
}

#subscribemain {
    font-size: 18px;
    line-height: 24px;
    margin-left: 8px;
}

#syncCalNotice {
    background-color: var(--uog-blue-10);
    padding: 2rem;
    display: flex;
    margin: 1rem 0px;
}

#syncCalNotice svg {
    color: var(--uog-dark-blue);
    height: 25px;
}

#syncCalNotice p {
    margin-bottom:0px;
    margin-left: 1rem;
}

@media(max-width: 550px) {
    #syncCalNotice {
        padding: 1rem;
    }
}

#syncLinks {
    padding-left: 0px;
    list-style-type: none;
}

#syncLinks li {
    border-top: solid 1px #ccc;
    display: flex;
}

#syncLinks li:last-child{
    border-bottom: solid 1px #ccc;
}

#syncLinks li a {
    padding: 1rem 1rem 1rem 0.5rem;
    text-decoration:none;
    color: var(--uog-dark-blue);
    width: 100%;
    display: flex;
    align-items:center;
}

#syncLinks li a span {
    flex-grow:1;
}

#syncLinks li a:active {
    background-color: var(--uog-blue-10);
}


@media(hover: hover) {
  #syncLinks li a:hover {
    background-color: var(--uog-blue-10);
    text-decoration:underline;
  }
}
</style>
